var _path, _ellipse, _ellipse2, _line;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFaceNeutral(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cc-face-neutral",
    d: "M23.9,47.8C37,47.8,47.7,37,47.7,23.9C47.7,10.7,37,0,23.9,0S0,10.7,0,23.9C0,37,10.7,47.8,23.9,47.8z",
    fill: "#AEAEAE"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 16.9,
    cy: 17.8,
    rx: 4.3,
    ry: 6
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 30.7,
    cy: 17.8,
    rx: 4.3,
    ry: 6
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 13.2,
    y1: 33.5,
    x2: 36.2,
    y2: 33.5,
    stroke: "#000000",
    strokeWidth: 1.25
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaceNeutral);
export default __webpack_public_path__ + "static/media/face-neutral.c744abc78d726a38d7ffab1198d09c3b.svg";
export { ForwardRef as ReactComponent };